module.exports = __webpack_public_path__ + "static/cloud-3-8ba09d9eef02a55a7c1785754c12f455.png";